<template>
        <a class="btn btn-danger btn-sm" style="border-radius: 50px !important;" @click.prevent="deletePromotion(promotionId)" href="#">
            <span>Delete</span>
<!--
            <i class="fas fa-trash"></i>
-->
        </a>
</template>

<script>
    export default {
        props:[
            'proId',
        ],
        data() {
            return{
                promotionId: null,
            }
        },
        mounted() {

                this.promotionId = this.proId;
        },
        methods: {
            deletePromotion(id){
                let self = this;
                axios({
                    method: "delete",
                    url: "/api/v1/trader-promotion/"+id+"?&api_token=" + window.api_token,
                })
                    .then(function(res) {
                        if (res.data.ok) {
                            self.$toast.success(res.data.msg);
                            self.$emit('update');
                        } else {
                            self.$toast.error(res.data.msg);
                        }
                    })
                    .catch(function(err) {
                        console.log(err);
                        if (err.response.status == 422) {
                            let errors = err.response.data.data;
                            self.errors = errors;
                            for (let error in errors) {
                                self.$toast.error(errors[error][0]);
                            }
                        }
                    });

            },

        }
    }
</script>

<style scoped>

</style>